"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styles = _interopRequireDefault(require("../styles"));
var _CardActions = _interopRequireDefault(require("@mui/material/CardActions"));
var _getLegacySpacingModeCss = _interopRequireDefault(require("./internal/getLegacySpacingModeCss"));
var _Card = require("./Card");
var _classnames = _interopRequireDefault(require("classnames"));
var _tokens = require("../styles/tokens");
var _excluded = ["classes"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var styles = function styles(theme) {
  var _responsive;
  return {
    // MUI classes
    root: {},
    spacing: {},
    // Custom Path classes
    standard: {
      padding: _tokens.spacing40
    },
    dense: {
      padding: "0.75rem " + _tokens.spacing30
    },
    none: {
      padding: 0
    },
    responsive: (_responsive = {}, _responsive[theme.breakpoints.only('xs')] = {
      padding: _tokens.spacing30 + " 0"
    }, _responsive)
  };
};

/**
 * CardActions component for displaying actions on a Card component
 */
var CardActions = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
  var classes = props.classes,
    rest = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
  var classesOverrides = (0, _getLegacySpacingModeCss.default)((0, _react.useContext)(_Card.CardContext), classes);
  var classOverrides = {
    root: (0, _classnames.default)(classes.root, classesOverrides),
    spacing: classes.spacing
  };
  return /*#__PURE__*/_react.default.createElement(_CardActions.default, (0, _extends2.default)({}, rest, {
    classes: classOverrides,
    ref: ref
  }));
});
CardActions.muiName = 'CardActions';
CardActions.displayName = 'CardActions';
CardActions.propTypes = {
  /**
   * The content of the component.
   */
  children: _propTypes.default.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes.default.object,
  /**
   * @ignore
   */
  className: _propTypes.default.string,
  /**
   * If `true`, the card actions do not have additional margin.
   */
  disableSpacing: _propTypes.default.bool,
  /**
   * 	The system prop that allows defining system overrides as well as additional CSS styles
   */
  sx: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object, _propTypes.default.bool])), _propTypes.default.func, _propTypes.default.object])
};
CardActions.defaultProps = {
  disableSpacing: false
};
var _default = (0, _styles.default)(styles)(CardActions);
exports.default = _default;